/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListHerdsByOrganizationQueryResponse, ListHerdsByOrganizationPathParams, ListHerdsByOrganizationQueryParams, ListHerdsByOrganization400, ListHerdsByOrganization401, ListHerdsByOrganization403, ListHerdsByOrganization404, ListHerdsByOrganization409, ListHerdsByOrganization500 } from "../../types/livestockController/ListHerdsByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListHerdsByOrganizationUrl(organizationId: ListHerdsByOrganizationPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/herds` as const }
  return res
}

/**
 * @summary List herds across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/herds}
 */
export async function listHerdsByOrganization(organizationId: ListHerdsByOrganizationPathParams["organizationId"], params?: ListHerdsByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListHerdsByOrganizationQueryResponse, ResponseErrorConfig<ListHerdsByOrganization400 | ListHerdsByOrganization401 | ListHerdsByOrganization403 | ListHerdsByOrganization404 | ListHerdsByOrganization409 | ListHerdsByOrganization500>, unknown>({ method : "GET", url : getListHerdsByOrganizationUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}